<cs-icon-button [attr.small]="size === 'small' ? '' : null" [attr.x-small]="size === 'x-small' ? '' : null"
  [attr.large]="size === 'large' ? '' : null" [icon]="name" (click)="onClick($event)"></cs-icon-button>
